var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"inner"},[(_vm.isMobile)?_c('mobile-control'):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('pc-control'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/home/examintro.vue?vue&type=template&id=4d371d10&scoped=true
// module id = null
// module chunks = 